import React from 'react';
import { Layout } from 'react-admin';
import { useDispatch } from 'react-redux';

import { SocketProvider } from '../contexts/SocketProvider';
import EventBannerProvider from '../contexts/EventBannerProvider';
import { TerminalsProvider } from '../contexts/TerminalsProvider';
import { OwnerCompanyDataProvider } from '../contexts/OwnerCompanyDataProvider';
import { UserSettingsProvider, useUserSettingsContext } from '../contexts/UserSettingsProvider';

import { MyAppBar } from './AppBar';


export const MyLayout = props => {    
    const { data: userSettings } = useUserSettingsContext();
    const dispatch = useDispatch();

    React.useEffect(() => {
        if (userSettings) {
            dispatch({ type: 'SET_SIDEBAR_OPEN', payload: !userSettings.is_menu_collapse });
        }
    }, [userSettings]);

    return (<Layout {...props} appBar={MyAppBar} />)
};


export default (props) => (
    <SocketProvider>
        <EventBannerProvider>
            <TerminalsProvider>
                <OwnerCompanyDataProvider>
                    <UserSettingsProvider>
                        <MyLayout {...props} />
                    </UserSettingsProvider>
                </OwnerCompanyDataProvider>
            </TerminalsProvider>
        </EventBannerProvider>
    </SocketProvider>
);
